import React, { useCallback, useMemo, useState } from 'react';
import { Select, Switch, Typography } from 'antd';

import { fetchCollectionHistory } from '../../services/history';
import { FEED_TYPE_OPTIONS } from '../../utils/history';
import HistoryList from '../history/HistoryList';
import DeletedItemHistoryModal from '../history/DeletedItemHistoryModal';

const { Text } = Typography;

/**
 * The collection's change feed (manage-gated on the API): every change to
 * its items, cards, settings, sharing, saved filters, automations and share
 * links, newest first. Derived system recomputes are hidden unless asked
 * for; a type filter narrows the feed. An item's deletion — a delete, or an
 * intake submission's reject — offers **View history**: the rest of that
 * item's history, read-only, the one door to it while the item is gone.
 */
export default function HistoryTab({ collectionId }) {
	const [type, setType] = useState(undefined);
	const [derived, setDerived] = useState(false);
	const [deletedItem, setDeletedItem] = useState(null);

	const filters = useMemo(() => ({ type, derived }), [type, derived]);
	const fetchPage = useCallback(params => fetchCollectionHistory(collectionId, params), [collectionId]);

	return (
		<div className="settings-column history-tab">
			<p>
				<Text type="secondary">
					Who changed what in this collection, newest first. Managers see every change; a change can be
					reverted where it still applies.
				</Text>
			</p>
			<div className="history-tab__toolbar">
				<Select
					allowClear
					className="history-tab__select"
					placeholder="Any kind of change"
					value={type}
					options={FEED_TYPE_OPTIONS}
					onChange={setType}
				/>
				<label className="history-tab__toggle">
					<Switch size="small" checked={derived} onChange={setDerived} />
					<span>Show system recomputes</span>
				</label>
			</div>
			<HistoryList fetchPage={fetchPage} filters={filters} onOpenItemHistory={setDeletedItem} />
			<DeletedItemHistoryModal entry={deletedItem} onClose={() => setDeletedItem(null)} />
		</div>
	);
}
